module.exports = __webpack_public_path__ + "img/265.aaeaad5e.jpg";